import { yupResolver } from "@hookform/resolvers/yup";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import * as yup from "yup";
import AuthApi from "../../apis/auth.api";
import AppAlert from "../../components/AppAlert";
import SolidBlueBtn from "../../components/buttons/SolidBlueBtn";
import AppInputPassword from "../../components/controls/AppInputPassword";
import Spinner from "../../components/spinner/Spinner";
import TopPageBack from "../../components/TopPageBack";
import { ROUTE_PATHS } from "../../constants/Router";

const ChangePassword = function () {
  const [openValidation, setOpenValidation] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const state = location.state;
  const navigate = useNavigate()

  const schema = yup.object().shape({
    newPassword: yup.string().required(),
    confirmPassword: yup.string().required(),
  });
  const { control, handleSubmit, watch } = useForm({
    resolver: yupResolver(schema),
  });

  const onSubmit = async (data) => {
    const { newPassword, confirmPassword } = data;
    const passwordPattern = /^(?=.*[a-z])(?=.*[0-9])(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{5,20}$/;
    if (!passwordPattern.test(newPassword)) {
      setErrorMessage(
        "새 비밀번호는 영어, 숫자, 특수문자로 <br/> 이루어져야 하며, 5자에서 20자 사이여야 합니다."
      );
      setOpenValidation(true);
      return;
    }
    if (!passwordPattern.test(confirmPassword)) {
      setErrorMessage(
         "새 비밀번호는 영어, 숫자, 특수문자로 <br/> 이루어져야 하며, 5자에서 20자 사이여야 합니다."
      );
      setOpenValidation(true);
      return;
    }

    if (newPassword !== confirmPassword) {
      setErrorMessage("새 비밀번호 일치하지 않습니다.");
      setOpenValidation(true);
      return;
    }

    try {
      setLoading(true);
      const submitData = {
        id: state?.id,
        otp: state?.otp,
        newPassword: newPassword,
      };
      const res = await AuthApi.changePassword(submitData);

      if(res.data?.data !== 0 && res.data?.data !== undefined) {
        navigate(ROUTE_PATHS.ChangePasswordResult,{
          state: {
            password:newPassword
          }
        });
      }
      else {
        setErrorMessage(res.data?.result_msg);
        setOpenValidation(true);
      }

    } finally {
      setLoading(false);
    }
  };

  const values = watch();

  return (
    <div>
      <TopPageBack>
        <b>비밀번호 재설정</b>
      </TopPageBack>

      <div className="mt-4 mx-5">
        <form onSubmit={handleSubmit(onSubmit)}>
          <AppInputPassword
            control={control}
            name="newPassword"
            placeholder="영문, 숫자, 특수문자 5~20자"
            label="새 비밀번호"
            className="mb-5"
          />

          <AppInputPassword
            control={control}
            name="confirmPassword"
            placeholder="새 비밀번호를 한번 더 입력해 주세요."
            label="새 비밀번호 확인"
          />

          <div className="px-5 absolute w-full bottom-2 left-0">
            <SolidBlueBtn
              disabled={!values.confirmPassword || !values.newPassword || loading}
              className="w-full flex items-center justify-center"
              type="submit"
            >
              <Spinner isLoading={loading} />
              확인
            </SolidBlueBtn>
          </div>
        </form>
      </div>

      <AppAlert
        title={errorMessage}
        open={openValidation}
        onOk={() => setOpenValidation(false)}
        okText="확인"
        type="error"
      />
    </div>
  );
};
export default ChangePassword;
